import { render, staticRenderFns } from "./develop.vue?vue&type=template&id=171023a4&"
import script from "./develop.vue?vue&type=script&lang=js&"
export * from "./develop.vue?vue&type=script&lang=js&"
import style0 from "./develop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports